/**
 * Is voice typing available in this browser? (ADR-002 Part III §24.2, invariant I2.)
 *
 * `supported` when `window.SpeechRecognition ?? window.webkitSpeechRecognition` is a constructor: Chrome (Google),
 * Edge (Microsoft), Safari and every iPhone (Apple). Firefox has neither, so it is `unsupported` and the member
 * types or pastes. Capability detection only: never the user-agent, no network call, no permission prompt, and
 * never `available()`, `install()` or `processLocally`.
 */
export type SpeechSupport = 'supported' | 'unsupported';

/** The recogniser's constructor, or null. Only this module and session.ts look it up (I1). */
export function recogniserCtor(): (new () => unknown) | null {
  if (typeof window === 'undefined') return null;
  const w = window as unknown as Record<string, unknown>;
  const C = w['SpeechRecognition'] ?? w['webkitSpeechRecognition'];
  return typeof C === 'function' ? (C as new () => unknown) : null;
}

export function probe(): SpeechSupport {
  return recogniserCtor() ? 'supported' : 'unsupported';
}
